import { render, staticRenderFns } from "./DashboardNotification.vue?vue&type=template&id=5a33172c&scoped=true&"
import script from "./DashboardNotification.vue?vue&type=script&lang=js&"
export * from "./DashboardNotification.vue?vue&type=script&lang=js&"
import style0 from "./DashboardNotification.scss?vue&type=style&index=0&id=5a33172c&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5a33172c",
  null
  
)

export default component.exports